export const addOrUpdate = (obj, arr) => {
    const current = arr?.find(o => obj.id === o.id);
    if(current) current.quantity = parseInt(current.quantity)+1;
    else arr.push(obj)

    return arr;
  };